import { Link } from '@/shared/ui/link';
import { usePathname } from '@/shared/lib/navigation';
import { cn } from '@/shared/lib/utils';

export interface RouteTab {
  label: string;
  href: string;
}

/**
 * A section's tab bar, one route per tab. Render it from the section's layout so
 * it does not remount between tabs. The first tab is the section's index and is
 * matched exactly; the rest match their subtree.
 */
export function RouteTabs({ tabs, label }: { tabs: RouteTab[]; label: string }) {
  const pathname = usePathname();

  return (
    <nav aria-label={label} className="flex flex-wrap gap-1 border-b border-border pb-px">
      {tabs.map((tab, index) => {
        const isActive =
          index === 0
            ? pathname === tab.href
            : pathname === tab.href || pathname.startsWith(`${tab.href}/`);

        return (
          <Link
            key={tab.href}
            href={tab.href}
            aria-current={isActive ? 'page' : undefined}
            className={cn(
              'rounded-t-md border-b-2 px-3 py-2 text-sm font-medium transition-colors',
              isActive
                ? 'border-primary text-foreground'
                : 'border-transparent text-muted-foreground hover:text-foreground',
            )}
          >
            {tab.label}
          </Link>
        );
      })}
    </nav>
  );
}
